import React from "react";

import { S3_BUCKET } from "../Constants";

export type UpdatedPreview = {
    [key: number]: string;
};

export const getImageSrc = (imageKey: string, width: number, bucket: string, height: number, fit?: string) => {
    const options = {
        bucket: bucket,
        key: imageKey,
        edits: {
            resize: {
                width: width,
                height: height ? height : width,
                fit: fit ?? "contain",
                background: {
                    r: 255,
                    g: 255,
                    b: 255,
                    alpha: 1,
                },
            },
        },
    };
    const strRequest = JSON.stringify(options);
    const encRequest = btoa(strRequest);

    return `https://d3sticxdmgvhkp.cloudfront.net/${encRequest}`;
};

export const getPreviewUrl = (previews: UpdatedPreview[], index: number, fallback: string) => {
    return previews.find((obj) => obj[index] !== undefined)?.[index] ?? fallback;
};

export const updatePreviewUrls = (prev: UpdatedPreview[], index: number, url: string): UpdatedPreview[] => {
    const existingIndex = prev.findIndex((obj) => obj[index] !== undefined);

    if (existingIndex !== -1) {
        const newArr = [...prev];
        newArr[existingIndex] = { [index]: url };
        return newArr;
    }

    return [...prev, { [index]: url }];
};

const ProductImage = (props: { imageKey: string; width: number; height: number; fit: string; className: string }) => {
    return (
        <img
            alt=""
            className={props.className}
            src={getImageSrc(props.imageKey, props.width, S3_BUCKET, props.height, props.fit)}
        />
    );
};

export default ProductImage;
